import { Button, ButtonProps } from 'antd';
import * as React from 'react';
import { ArrowDownIcon } from '../../icons/arrow-down-icon';
import { ArrowUpIcon } from '../../icons/arrow-up-icon';

import IconWrapper from '../icon-wrapper/icon-wrapper';

interface ExpandTableParentIconProps {
  expanded: boolean;
  onClick: ButtonProps['onClick'];
}

export const ExpandTableParentIcon = ({ expanded, onClick }: ExpandTableParentIconProps) => {
  return (
    <Button
      type="text"
      shape="circle"
      icon={<IconWrapper>{expanded ? <ArrowUpIcon /> : <ArrowDownIcon />}</IconWrapper>}
      onClick={onClick}
    />
  );
};
